import * as React from "react"
import { useSelector, useDispatch } from "react-redux"
import DatePicker from "rmc-date-picker"
import 'rmc-date-picker/assets/index.css';
import 'rmc-picker/assets/index.css';
import 'rmc-picker/assets/popup.css';

import TextInput, { ITextInputProps } from "../TextInput"
import { isRequired, checkDateNotOverTodayDate } from "../../utils/validators"
import * as AppTypes from "AppTypes"
import { userInfoActions } from "../../actions"
import { Slide } from "@mui/material"

import "./override.scss"

interface IDateOfBirthFieldProps {
    cluster: ITextInputProps["cluster"]
    disabled?: boolean
}

const DateOfBirthField: React.FC<IDateOfBirthFieldProps> = props => {
    const dispatch = useDispatch()
    const { cluster, disabled } = props
    const { userInfo, langPack } = useSelector((store: AppTypes.ReducerState) => ({
        userInfo: store.userInfo,
        langPack: store.config.langPack
    }))

    const tabIndexElement = React.useRef<HTMLDivElement>(null)

    const [pickerValue, setPickerValue] = React.useState<Date>(null)
    const [forceDate, setForceDate] = React.useState({ value: "" })
    const [defaultDate, setDefaultDate] = React.useState(userInfo.dateOfBirth ? new Date(userInfo.dateOfBirth) : new Date())
    const [isPickerShow, setPickerShow] = React.useState(false)

    const handleUpdateUserInfo: ITextInputProps["onValidation"] = (validation) => {
        const { isValid, inputId, value } = validation

        if (isValid) {
            dispatch(userInfoActions.updateUserInfo({ [inputId]: value }))
        } else {
            dispatch(userInfoActions.updateUserInfo({ [inputId]: "" }))
        }
    }

    const onConfirm = (value: Date) => {
        if (!value) value = defaultDate
        const dob = value.toISOString().split("T")[0]
        setForceDate({ value: dob })
        setDefaultDate(new Date(dob))
        setTimeout(() => {
            if (typeof cluster["dateOfBirth"] === "function") {
                cluster["dateOfBirth"]()
            }
        }, 100)
    }

    return (
        <div id="dateOfBirth">

            <div
                tabIndex={0}
                data-testid="dob-container"
                onFocus={() => setPickerShow(true)}
                onBlur={() => setPickerShow(false)}
                style={{ outline: "none" }}
                ref={tabIndexElement}
            >
                <TextInput
                    inputLabel={langPack["labelDateOfBirth"]}
                    initValue={userInfo.dateOfBirth}
                    forceUpdate={forceDate}
                    max={new Date().toISOString().split("T")[0]}
                    inputId={"dateOfBirth"}
                    validators={[isRequired, checkDateNotOverTodayDate]}
                    cluster={cluster}
                    onValidation={handleUpdateUserInfo}
                    type="date"
                    disabled={true}
                />

                <Slide
                    direction="up"
                    in={isPickerShow && !disabled}
                >
                    <div className="dob-slide__wrapper">
                        <div className="dob-slide__action">
                            <div
                                className="dob-slide__button"
                                data-testid="dob-slide__button"
                                onClick={() => {
                                    onConfirm(pickerValue)
                                    setPickerShow(false)
                                    tabIndexElement.current.blur()
                                }}>Done</div>
                        </div>
                        <DatePicker
                            rootNativeProps={{ 'data-xx': 'yy' }}
                            className="app-dob-sg"
                            minDate={new Date(1885, 1, 1)}
                            maxDate={new Date()}
                            mode={"date"}
                            defaultDate={defaultDate}
                            formatMonth={mon => {
                                return [
                                    "January", "February", "March", "April",
                                    "May", "June", "July", "August",
                                    "September", "October", "November", "December"
                                ][mon]
                            }}
                            onDateChange={(value) => setPickerValue(value)}
                            
                        />
                    </div>
                </Slide>
            </div>
        </div >
    )
}

export default DateOfBirthField
